var hashHas = require('./_hashHas');

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(hash, key) {
  return hashHas(hash, key) && delete hash[key];
}

module.exports = hashDelete;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-touch/node_modules/lodash/_hashDelete.js
// module id = ./node_modules/react-touch/node_modules/lodash/_hashDelete.js
// module chunks = main